module.exports = __webpack_public_path__ + "img/Product.77f04132.svg";